var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlyph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3954 10.2141V2.43676C12.3954 1.40638 11.5805 1.25 11.1226 1.25C10.4667 1.26303 5.33305 1.25 1.94827 1.25C1.10728 1.25 0.5 1.53062 0.5 2.42807V10.2011C0.5 10.9083 1.0873 11.2853 1.95695 11.2853H3.99252V9.88399H2.48865C2.17154 9.88399 1.96998 9.62683 1.96998 9.35751V3.19174C1.96998 3.16828 1.97346 3.14482 1.9778 3.12223C2.02906 2.84509 2.29752 2.73302 2.56076 2.73302H10.445C10.4502 2.73302 10.9124 2.72085 10.9124 3.2039V9.36532C10.9124 9.64768 10.7152 9.90484 10.4068 9.90484H8.89855V11.3062H10.9341C11.8081 11.2984 12.3954 10.9222 12.3954 10.2141Z",
    fill: "#00B0CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6748 7.78434V15.5617C5.6748 16.5921 6.48973 16.7485 6.94757 16.7485C7.60351 16.7354 12.7372 16.7485 16.1219 16.7485C16.9638 16.7485 17.5711 16.4678 17.5711 15.5704V7.7965C17.5711 7.08931 16.9838 6.71226 16.1141 6.71226H14.0786V8.11361H15.5824C15.8995 8.11361 16.1011 8.37077 16.1011 8.64009V14.8067C16.1011 14.8302 16.0976 14.8536 16.0933 14.8762C16.042 15.1534 15.7736 15.2654 15.5103 15.2654H7.62436C7.61915 15.2654 7.15695 15.2776 7.15695 14.7946V8.63227C7.15695 8.34992 7.35417 8.09276 7.66259 8.09276H9.1708V6.69141H7.1361C6.2621 6.70009 5.6748 7.07628 5.6748 7.78434Z",
    fill: "#AEB3C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4536 5.34607H14.1738V5.16797H14.9253V5.34607H14.6456V6.18879H14.4536V5.34607Z",
    fill: "#D4D6DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0723 5.16797H15.3668L15.5527 5.95943H15.5553L15.7421 5.16797H16.0279V6.18879H15.8437V5.33738H15.8411L15.6405 6.18879H15.4597L15.2591 5.33738H15.2556V6.18879H15.0723V5.16797Z",
    fill: "#D4D6DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlyph);
export default __webpack_public_path__ + "static/media/Glyph.e3aa558d628e9edb0ff9638ff4c480c3.svg";
export { ForwardRef as ReactComponent };